var map = {
	"./1.jpg": 195,
	"./10.jpg": 206,
	"./11.jpg": 677,
	"./12.jpg": 878,
	"./13.jpg": 861,
	"./2.jpg": 516,
	"./3.jpg": 628,
	"./4.jpg": 666,
	"./5.jpg": 401,
	"./6.jpg": 876,
	"./7.jpg": 814,
	"./8.jpg": 892,
	"./9.jpg": 3
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 395;